import React, { CSSProperties } from "react";
import cx from "classnames";
import style from "./label.module.scss";
import { Button } from "@geist-ui/core";

interface ILabel {
  value: string;
  className?: string;
  style?: CSSProperties;
  children: React.ReactNode;
}

export const Label = (props: ILabel) => {
  return (
    <label className={cx(style.label, props.className)} style={props.style}>
      <span className={style.label_title}>{props.value}</span>
      {props.children}
    </label>
  );
};

Label.defaultProps = {};
